module.exports = __webpack_public_path__ + "img/底部.a6c2575f.png";